import { render, staticRenderFns } from "./Logistics.vue?vue&type=template&id=7e3e24b5&scoped=true"
import script from "./Logistics.vue?vue&type=script&lang=js"
export * from "./Logistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3e24b5",
  null
  
)

export default component.exports